// ---------------------------------------------------------------------------
// DEV MOCK DATA — this is NOT real backend data.
//
// The dashboard is user-specific (activity, streak, schedule) and there is no
// authenticated session or GET /api/dashboard endpoint yet. Until that exists,
// the dashboard + hero preview render from these clearly-marked mocks so that
// no business data lives inside components. Swap `fetchDashboard()` in
// ../dashboard.ts for a real API call when the backend is ready.
// ---------------------------------------------------------------------------
import type { DashboardData, HeroPreview } from '../../types';

export const MOCK_DASHBOARD: DashboardData = {
  user: { name: 'Anshuman', greeting: 'Good Morning', streakDays: 12 },
  activity: {
    hoursSpent: 24.9,
    avgLabel: '4.2 hours',
    bars: [
      { day: 'Mon', value: 46 },
      { day: 'Tue', value: 34 },
      { day: 'Wed', value: 72 },
      { day: 'Thu', value: 52 },
      { day: 'Fri', value: 96, highlight: true },
      { day: 'Sat', value: 66 },
      { day: 'Sun', value: 80 },
    ],
  },
  platforms: [
    { name: 'WebFoxx platform', lessons: '8 lessons', hours: '12.5 h', iconKey: 'monitor', tone: 'orange' },
    { name: 'Zoom', lessons: '5 lessons', hours: '6.8 h', iconKey: 'video', tone: 'blue' },
    { name: 'Google Meet', lessons: '3 lessons', hours: '4.2 h', iconKey: 'video', tone: 'green' },
    { name: 'Skype', lessons: '2 lessons', hours: '2.5 h', iconKey: 'message', tone: 'sky' },
  ],
  progress: {
    totalActivityPercent: 64,
    segments: [
      { value: '24%', width: 24, tone: 'purple' },
      { value: '35%', width: 35, tone: 'green' },
      { value: '41%', width: 41, tone: 'orange' },
    ],
    tiles: [
      { label: 'In progress', value: '8', iconKey: 'clock', tone: 'purple' },
      { label: 'Completed', value: '12', iconKey: 'check', tone: 'green' },
      { label: 'Upcoming', value: '14', iconKey: 'calendar', tone: 'orange' },
    ],
  },
  course: {
    tags: [
      { label: 'CUET UG & PG', tone: 'green' },
      { label: 'Live Batch', tone: 'purple' },
    ],
    title: 'CUET General Test (GAT 501) & Domain Prep',
    description:
      'Master CUET GAT 501 and Domain / PG subjects with guided practice, mock tests, and past year questions — built specifically for NTA CUET UG & PG.',
    participantsInitials: ['AK', 'RM', 'NR', 'VS'],
    moreCount: 6,
    progressPercent: 75,
  },
  schedule: [
    {
      id: 'slot-1',
      time: '10:30 — 12:00',
      title: 'General Test (GAT 501) Logical Reasoning',
      level: 'CUET (UG)',
      mentor: 'Kristin Watson',
    },
    {
      id: 'slot-2',
      time: '13:00 — 14:00',
      title: 'CUET Domain / PG Subject Deep Dive',
      level: 'CUET (PG)',
      mentor: 'Cody Fisher',
      now: true,
    },
    {
      id: 'slot-3',
      time: '16:00 — 17:00',
      title: 'Numerical Ability & Data Interpretation',
      level: 'CUET (UG)',
      mentor: 'Jacob Jones',
    },
  ],
};

// Illustrative preview shown inside the marketing hero (not the signed-in user).
export const HERO_PREVIEW: HeroPreview = {
  greeting: 'Good Morning',
  name: 'Anshuman',
  streakDays: 12,
  todaysGoalPercent: 82,
  averageAccuracyPercent: 74,
  continueTopic: 'General Test (GAT 501)',
  weakUnits: ['Logical Reasoning', 'General Mental Ability', 'Numerical Ability'],
  upcomingRevision: [
    { topic: 'General Test (GAT 501)', due: 'Due today' },
    { topic: 'Numerical Ability & DI', due: 'Due in 2h' },
    { topic: 'CUET Domain / PG Paper', due: 'Tomorrow' },
  ],
  liveFocusPercent: 74,
  liveFocusBars: [42, 68, 56, 82, 72, 91],
};
